export default __webpack_public_path__ + "static/media/humidity.946a3849.svg";